<template>
    <section class="home-hero">
        <v-container fluid fill-height class="home-hero__content">
            <v-row class="home-hero__content-row">
                <v-col class="home-hero__content">
                    <v-carousel
                        hide-delimiters
                        cycle
                        :show-arrows="false"
                    >
                        <v-carousel-item
                            v-for="(HomeItem, index) in HomeItems"
                            :key="index"                        
                            transition="scroll-x-transition"
                        >
                            <img  :src="HomeItem.src" class="home-hero__content-img">
                        </v-carousel-item>
                    </v-carousel>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>
<script>
import constants from '../common/constants'

export default {
    name: "HomeHero",
    data(){
        return {
            HomeItems: constants.HomeItems,
        }
    },
}
</script>

<style lang="scss" scoped>


.home-hero__content {
    justify-content: center;
    text-align: center;
    width: 100%;
    &-img {
        width: 100%;
        height: auto;
        max-width: 850px;
    }
    &-row {
        justify-content: center;
    }
}

</style>